/* Recycle real cards for a continuous alternating sequence without inaccessible clones. */
(function () {
  'use strict';
  function mount(root) {
    if (root.dataset.testimonialMounted) return;
    root.dataset.testimonialMounted = 'true';
    var viewport = root.querySelector('[data-testimonial-viewport]');
    var track = root.querySelector('[data-testimonial-track]');
    var pause = root.querySelector('[data-testimonial-pause]');
    var activeCard = null;
    var players = root.querySelectorAll('[data-testimonial-player]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var position = viewport.scrollLeft;
    var userPaused = false, visible = false, previousTime = null, lastSet = -1, resumeTimer = null, interacting = false;
    var animation;
    function paused() { return userPaused || interacting || !visible || reduced.matches || document.hidden || activeCard !== null; }
    function pitch() {
      return track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : 0;
    }
    /* Keep the viewport between one and two card widths from the start so cards recycle in both directions with no empty gap. */
    function normalize() {
      var distance = pitch();
      if (!distance || track.children.length < 2) return;
      var changed = false;
      while (position >= 2 * distance) { track.appendChild(track.firstElementChild); position -= distance; changed = true; }
      while (position < distance) { track.insertBefore(track.lastElementChild, track.firstElementChild); position += distance; changed = true; }
      if (changed || Math.round(position) !== viewport.scrollLeft) { lastSet = Math.round(position); viewport.scrollLeft = lastSet; }
    }
    function tick(time) {
      if (!root.isConnected) { cleanup(); return; }
      if (!paused() && previousTime !== null) {
        position += Math.min(time - previousTime, 100) * 0.04;
        normalize();
      } else if (previousTime === null) {
        normalize();
      }
      previousTime = time;
      animation = requestAnimationFrame(tick);
    }
    function setUserPaused(value) {
      userPaused = value;
      pause.setAttribute('aria-pressed', String(value));
      pause.textContent = value ? 'Resume movement' : 'Pause movement';
    }
    function manual(direction) {
      if (activeCard) stop(activeCard, false);
      position += direction * pitch();
      normalize();
    }
    function userMoved() {
      interacting = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { interacting = false; position = viewport.scrollLeft; previousTime = null; }, 1500);
    }
    root.querySelector('[data-testimonial-prev]').addEventListener('click', function () { manual(-1); });
    root.querySelector('[data-testimonial-next]').addEventListener('click', function () { manual(1); });
    pause.addEventListener('click', function () { if (userPaused && activeCard) stop(activeCard, false); setUserPaused(!userPaused); });
    viewport.addEventListener('pointerdown', userMoved);
    viewport.addEventListener('wheel', userMoved, { passive: true });
    viewport.addEventListener('touchmove', userMoved, { passive: true });
    viewport.addEventListener('scroll', function () {
      if (viewport.scrollLeft === lastSet) return;
      position = viewport.scrollLeft;
      if (interacting) normalize();
    }, { passive: true });
    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        manual(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    function stop(card, restoreFocus) {
      var player = card.querySelector('[data-testimonial-player]');
      player.pause(); player.removeAttribute('src'); player.replaceChildren(); player.load(); player.hidden = true;
      card.querySelector('[data-testimonial-open]').hidden = false;
      card.querySelector('[data-testimonial-stop]').hidden = true;
      card.querySelector('[data-testimonial-error]').hidden = true;
      if (activeCard === card) activeCard = null;
      if (restoreFocus) card.querySelector('[data-testimonial-open]').focus({ preventScroll: true });
    }
    root.addEventListener('click', function (event) {
      var stopButton = event.target.closest('[data-testimonial-stop]');
      if (stopButton) { stop(stopButton.closest('[data-testimonial-video-card]'), true); return; }
      var button = event.target.closest('[data-testimonial-open]');
      if (!button) return;
      var card = button.closest('[data-testimonial-video-card]');
      if (activeCard) stop(activeCard, false);
      activeCard = card;
      var player = card.querySelector('[data-testimonial-player]');
      setUserPaused(true);
      card.querySelector('[data-testimonial-error]').hidden = true;
      player.src = button.dataset.video;
      if (button.dataset.caption) {
        var captions = document.createElement('track');
        captions.kind = 'captions'; captions.label = 'English'; captions.srclang = 'en'; captions.src = button.dataset.caption;
        player.appendChild(captions);
      }
      button.hidden = true; player.hidden = false;
      card.querySelector('[data-testimonial-stop]').hidden = false;
      player.focus({ preventScroll: true });
      player.play().catch(function () { /* Native play controls remain available if playback is declined. */ });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeCard) { event.preventDefault(); stop(activeCard, true); }
    });
    players.forEach(function (player) {
      var card = player.closest('[data-testimonial-video-card]');
      player.addEventListener('error', function () { if (activeCard === card) card.querySelector('[data-testimonial-error]').hidden = false; });
      player.addEventListener('ended', function () { stop(card, true); });
    });
    var observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.05 });
    observer.observe(viewport);
    function cleanup() { cancelAnimationFrame(animation); observer.disconnect(); if (activeCard) stop(activeCard, false); }
    animation = requestAnimationFrame(tick);
    document.addEventListener('shopify:section:unload', function (event) { if (event.target.contains(root)) cleanup(); });
  }
  document.querySelectorAll('[data-testimonial-marquee]').forEach(mount);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-testimonial-marquee]').forEach(mount); });
})();
